import * as React from "react";
import { Label } from "../Label";
import { DateTime } from "../DateTime";
export class League extends React.Component {
    render() {
        return (React.createElement("span", { className: "rj-racing-future-events__league" },
            React.createElement(Label, { label: this.props.label }),
            React.createElement(DateTime, { date: this.props.date, time: this.props.time })));
    }
}
//# sourceMappingURL=League.js.map